import instance from "../../../services/api";

export const keyReceiveAPI = {
  async getList(remont_id) {
    return instance().get(`/partner/remont/${remont_id}/key_receive/read/`)?.then(res => res?.data)
  },
  async getKeyCounts(remont_id) {
    return instance().get(`/partner/remont/${remont_id}/key_receive/key_trinket/count/get/`)?.then(res => res?.data)
  },
}